 export const API_URL = "https://test.opposingcylinders.com/api";
export const WASABI_URL = "https://s3.us-east-1.wasabisys.com/vehicle-project/";
